import { QueryClient } from '@tanstack/react-query';

// Simple QueryClient - like other-project (default settings)
export const queryClient = new QueryClient();

// Query keys for consistent caching
export const queryKeys = {
  siteSettings: ['siteSettings'] as const,
  pages: {
    all: ['pages'] as const,
    list: () => [...queryKeys.pages.all, 'list'] as const,
    detail: (slug: string) => [...queryKeys.pages.all, 'detail', slug] as const,
  },
  services: {
    all: ['services'] as const,
    list: () => [...queryKeys.services.all, 'list'] as const,
    detail: (slug: string) => [...queryKeys.services.all, 'detail', slug] as const,
  },
  blog: {
    all: ['blog'] as const,
    list: (params?: { category?: string; page?: number }) => [...queryKeys.blog.all, 'list', params] as const,
    detail: (slug: string) => [...queryKeys.blog.all, 'detail', slug] as const,
  },
  caseStudies: {
    all: ['caseStudies'] as const,
    list: () => [...queryKeys.caseStudies.all, 'list'] as const,
    detail: (slug: string) => [...queryKeys.caseStudies.all, 'detail', slug] as const,
  },
  testimonials: {
    all: ['testimonials'] as const,
    list: () => [...queryKeys.testimonials.all, 'list'] as const,
    featured: () => [...queryKeys.testimonials.all, 'featured'] as const,
  },
  leads: {
    all: ['leads'] as const,
    list: (params?: { status?: string; page?: number }) => [...queryKeys.leads.all, 'list', params] as const,
    detail: (id: string) => [...queryKeys.leads.all, 'detail', id] as const,
  },
  media: {
    all: ['media'] as const,
    list: (folder?: string) => [...queryKeys.media.all, 'list', folder] as const,
  },
  faqs: {
    all: ['faqs'] as const,
    list: () => [...queryKeys.faqs.all, 'list'] as const,
    featured: () => [...queryKeys.faqs.all, 'featured'] as const,
  },
  profile: (userId: string) => ['profile', userId] as const,
  adminStats: ['adminStats'] as const,
};
